import { useEffect } from "react";
import { useQuery } from "react-query";

export default function useTranslation(
  targetLanguage: string | undefined,
  contentType: string,
  contentId: string | undefined,
) {
  useEffect(() => {
    if (targetLanguage === undefined) {
      const url = new URL(window.location.href);
      if (url.searchParams.has("lng")) {
        url.searchParams.delete("lng");
        window.history.replaceState({}, "", url.toString());
      }
    } else {
      const url = new URL(window.location.href);
      if (url.searchParams.get("lng") !== targetLanguage) {
        url.searchParams.set("lng", targetLanguage);
        window.history.replaceState({}, "", url.toString());
      }
    }
  }, [targetLanguage]);

  return useQuery(
    `/translations/${targetLanguage}/${contentType}/${contentId}`,
    {
      enabled: !!(targetLanguage && contentId),
      refetchOnWindowFocus: false,
    },
  );
}
